exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:1500px){.container-fluid[data-v-71d9058d]{width:80%}}@media (min-width:2000px){.container-fluid[data-v-71d9058d]{width:60%}}.lnk[data-v-71d9058d]{cursor:pointer}.back-to-top[data-v-71d9058d]{cursor:pointer;position:fixed;bottom:20px;right:20px;display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-71d9058d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/projects/ProjectList.vue
// module id = 113
// module chunks = 0